/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from 'react';
import { default as axios } from 'axios';
import moment from 'moment-timezone';
import SignatureCanvas from 'react-signature-canvas-react17-compatible';
import styles from './Timesheet.module.scss';
import LogoHeader from '../../components/LogoHeader/LogoHeader';
import SheetHeader from '../../components/SheetHeader/SheetHeader';
import BasicInfo from '../../components/BasicInfo/BasicInfo';
import DayEntry from '../../components/DayEntry/DayEntry';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import Disclaimer from '../../components/Disclaimer/Disclaimer';
import Signature from '../../components/Signature/Signature';
import InfoModal from '../../components/InfoModal/InfoModal';
import disclaimerOptions from '../../components/Disclaimer/disclaimerOptions';
import TextInput from '../../components/TextInput/TextInput';
import { Formik } from 'formik'
import * as Yup from 'yup';
import { PencilFill, Trash } from 'react-bootstrap-icons';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import Questions from '../../components/Questions/Questions';
import SupervisorInitials from "../../components/SupervisorInitials/SupervisorInitials"

const enableSupervisorInitials = `${process.env.REACT_APP_ENABLE_SUPERVISOR_INITIALS}` === "true"

declare global {
  interface Window {
    grecaptcha?: any;
    analytics: any;
  }
}
export type basicInfoProps = {
  state?: string;
  email?: string;
  employeeFirstName?: string;
  employeeLastName?: string;
  unit?: string;
  last5SSN?: number;
};

export type dayEntryType = {
  timeIn?: string;
  date?: string;
};

export type dayEntry = {
  date: string;
  [key: string]: string;
}

export interface InitialDays {
  Monday?: SignatureCanvas;
  Tuesday?: SignatureCanvas;
  Wednesday?: SignatureCanvas;
  Thursday?: SignatureCanvas;
  Friday?: SignatureCanvas;
  Saturday?: SignatureCanvas;
  Sunday?: SignatureCanvas;
}

type TimesheetType = 'cce' | 'cce-subs'

interface TimesheetProps {
  type?: TimesheetType
}

const Timesheet = ({ type = 'cce' }: TimesheetProps) => {
  const [basicInfo, setBasicInfo] = useState<basicInfoProps>({});
  const [dayEntry, setDayEntry] = useState<dayEntry[]>([]);
  const [disclaimerChecked, setDisclaimerChecked] = useState();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalData, setModalData] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState<boolean>(true);
  const [sigTouched, setSigTouched] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sigTouchedManager, setSigTouchedManager] = useState<boolean>(false);
  const [dutyFreeLunchSchoolSigTouched, setDutyFreeLunchSchoolSigTouched] = useState<boolean>(false);
  const [dutyFreeBreakSchoolSigTouched, setDutyFreeBreakSchoolSigTouched] = useState<boolean>(false);
  const sigCanvas = useRef<SignatureCanvas>({});
  const sigCanvasManager = useRef<SignatureCanvas>({});
  const dutyFreeLunchSchoolInitials = useRef<SignatureCanvas>({});
  const dutyFreeBreakSchoolInitials = useRef<SignatureCanvas>({});
  const [isLoading, setLoading] = useState<boolean>(false);
  const [showHasDay, setHasDay] = useState<boolean>(false);
  const [supervisorFullName, setSupervisorFullName] = useState();
  const [isformValid, setIsFormValid] = useState(true)
  const [isTimesheetSubmit, setIsTimeSheetSubmit] = useState(false)
  const [showEntryform, setShowEntryform] = useState(true)
  const [confirmationBox, setConfirmatioBox] = useState(false)
  const [entryIndex, setEntryIndex] = useState<any>(null);
  const [editEntry, setEditEntry] = useState(false);
  const [tableRowsCount, setTableRowsCount] = useState('')
  const [entryData, setEntryData] = useState({})
  const [questionResponses, setQuestionResponses] = useState({})
  const [isQuestionvalidate, setIsQuestionvalidate] = useState(true)
  const [initialsDays, setInitialsDays] = useState<InitialDays>({});
  const [isUpdateEntry, setIsUpdateEntry] = useState<boolean>(false)
  const [updatedDay, setIsUpdatedDay] = useState<string | null>()
  const [previousDate, setPreviousDate] = useState<string | null>()
  var timesheetData: {
    token?: string;
    type?: string;
    timezone?: string;
    termsAccepted?: string;
    signature?: string;
    supervisorSignature?: string;
    supervisorFullName?: string;
    dutyFreeBreakSchoolInitials?: any;
    dutyFreeLunchSchoolInitials?: any;
    currentDateTime?: string;
    weekIn?: any;
    weekOut?: any;
  } = {};

  const SITE_KEY = `${process.env.REACT_APP_RECAPTCHA_KEY}`;
  const timesheetAPI = `${process.env.REACT_APP_TIMESHEET_API}`;

  useEffect(() => {
    if (!dayEntry.length) {
      setHasDay(false);
    } else {
      setHasDay(true)
    }
  }, [dayEntry.length])

  useEffect(() => {
    window.scrollTo(0, 0);
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);
      if (!isScriptExist) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    // load the script by passing the URL
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`,
      function () {

      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * when required fields (basicInfo) and all signatures are completed and disclaimer is checked submit button will enable
   */

  useEffect(() => {
    if (disclaimerChecked && sigTouched && !sigCanvas.current.isEmpty() && checkNull(basicInfo) && showHasDay && isQuestionvalidate) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true)
    };
  }, [disclaimerChecked, sigTouched, sigTouchedManager, basicInfo, isQuestionvalidate, showHasDay]);

  useEffect(() => {
    if (basicInfo.state === 'other') {
      setIsQuestionvalidate(true);
    } else {
      setIsQuestionvalidate(false);
    }
  }, [basicInfo.state]);

  const getSupervisorInitials = () => {
    return Object.keys(initialsDays).reduce((supervisorInitials: { [key: string]: any }[], day) => {
      const potentialInitial = initialsDays[day];
      const trimmedCanvas = potentialInitial?.getTrimmedCanvas();

      if (trimmedCanvas) {
        const signatureKey = `${day.toLowerCase()}SupervisorInitials`;
        const signature = trimmedCanvas.toDataURL("image/png");

        supervisorInitials.push({
          [signatureKey]: signature
        });
      }

      return supervisorInitials;
    }, []);
  }
  const removeSupervisorInitialsEntry = (day: string) => {
    if (initialsDays.hasOwnProperty(day)) {
      const updatedInitialsDays = { ...initialsDays };
      delete updatedInitialsDays[day];

      setInitialsDays(updatedInitialsDays);
    }
  };

  /**
   * Takes in an object and checks it for an null, undefined, or empty string values
   * @param target object which you want to check for null or missing values
   * @returns boolean
   */
  const checkNull = (target) => {
    for (var member in target) {

      if (member !== 'department') {
        if (
          target[member] == null ||
          target[member] === undefined ||
          target[member] === ''
        )
          return false;
      }
    }
    return true;
  };

  /**
   * called from submitForm when token is received and required fields are filled
   * @param token google recaptcha token
   */
  const submitData = async (obj) => {

    // call a backend API to verify reCAPTCHA response
    setLoading(true);
    try {
      const response = axios.post(timesheetAPI, obj);
      window.analytics.identify('TIMESHEET_SUBMITTED', obj)
      await response.then((res) => {
        if (res.status === 200) {
          window.location.assign('/success');
        } else throw new Error('Response not 200 OK');
      });
    } catch (error) {
      setModalData({
        code: 101,
        message: 'An error occurred while submitting your timesheet.',
        type: 'Error',
      });
      setShowModal(true);
      setLoading(false);
    }
  };

  const removeEmptyKeys = (obj) => {
    Object.keys(obj).forEach(key => {
      if (!obj[key]) {
        delete obj[key];
      }
    });
  }

  /**
   * if there are no nulls in required field, gets captcha
   */
  const submitForm = (setSubmitting) => {
    if (submitDisabled || isLoading || !showHasDay) {
      setSubmitting(false);
      return false
    }
    if (checkNull(basicInfo) && disclaimerChecked && isformValid) {
      let SupervisorInitials;
      if (enableSupervisorInitials) SupervisorInitials = getSupervisorInitials();
      try {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(SITE_KEY, { action: 'submit' })
            .then((token) => {
              timesheetData = {
                token: token,
                type,
                currentDateTime: moment().format(),
                weekIn: moment(dayEntry[0].date).startOf('week').toDate(),
                weekOut: moment(dayEntry[0].date).endOf('week').toDate(),
                supervisorFullName: supervisorFullName,
                timezone: moment.tz.guess(),
                company: "cce",
                ...basicInfo,
                ...dayEntry.reduce(((r, c) => Object.assign(r, c)), {}),
                ...questionResponses,
                ...(enableSupervisorInitials && SupervisorInitials.reduce(((r, c) => Object.assign(r, c)), {})),
                termsAccepted:
                  basicInfo?.state === 'ca'
                    ? disclaimerOptions.ca
                    : disclaimerOptions.other,
                signature: sigCanvas.current
                  .getTrimmedCanvas()
                  .toDataURL('image/png'),
                supervisorSignature: sigTouchedManager ? sigCanvasManager.current
                  .getTrimmedCanvas().toDataURL('image/png') : '',
              };
              removeEmptyKeys(timesheetData)
              try {
                window.analytics.identify('TIMESHEET_SUBMITTED', {
                  ...timesheetData,
                  signature: sigCanvas.current.getTrimmedCanvas().toDataURL('image/png') ? true : false,
                  supervisorSignature: sigTouchedManager ? true : false,
                }
                )
                window.analytics.identify('BASIC_INFO', {
                  firstname: basicInfo?.employeeFirstName,
                  lastname: basicInfo?.employeeLastName,
                });
              } catch (error2) {

              }
              submitData(timesheetData);
            });
        });
      } catch (error) {
        setModalData({
          code: 100,
          message: 'An error has occurred with saving your data.',
          type: 'Error',
        });
        setShowModal(true);
      }
      setSubmitting(false);
      setIsTimeSheetSubmit(false);
    } else {
      setSubmitting(false);
      window.scrollTo(0, 0);
      return false
    }
  };

  const timesheetSchema = Yup.object().shape({
    firstName: Yup.string().required('Please enter first name'),
    lastName: Yup.string().required('Please enter last name'),
    state: Yup.string().nullable().required('Please select state'),
    schoolDistrict: Yup.string().required('Please enter school district'),
    profession: Yup.string().required('Please enter profession'),
    // department: Yup.string().required('Please enter department'),
    email: Yup.string().matches(/^[a-zA-Z][\w.-]{1,28}[a-zA-Z0-9]@[a-zA-Z0-9][\w.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z.]*[a-zA-Z]$/,
      'Please enter a valid email address'
    ).required('Please enter email address'),
  });

  const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  return (
    <div className={styles.Timesheet} data-testid="Timesheet">
      <LogoHeader />
      <Container className={styles.Sheet}>
        <SheetHeader />
        <Formik
          initialValues={{
            email: '',
            state: undefined,
            profession: '',
            schoolDistrict: '',
            firstName: '',
            lastName: '',
            timeOut: '',
            timeIn: '',
            firstStartTime: '',
            firstEndTime: '',
            secondStartTime: '',
            secondEndTime: '',
            hourType1: undefined,
            hour1: '',
            hourType2: undefined,
            hour2: '',
            disclaimer: false,
            signature: '',
          }}
          validationSchema={timesheetSchema}
          onSubmit={(values, { setSubmitting }) => {
            submitForm(setSubmitting)
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form id='timesheet' onSubmit={handleSubmit}>
              <BasicInfo
                infoData={setBasicInfo}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                isSubmitting={isTimesheetSubmit}
              />
              {
                (showEntryform || !showHasDay) &&
                <DayEntry
                  setEntryIndex={setEntryIndex}
                  setShowEntryform={setShowEntryform}
                  setIsFormValid={setIsFormValid}
                  setEditEntry={setEditEntry}
                  entryIndex={entryIndex}
                  tableEntryArray={dayEntry}
                  isEditEntry={editEntry}
                  setIsUpdateEntry={setIsUpdateEntry}
                  setIsUpdatedDay={setIsUpdatedDay}
                  setPreviousDate={setPreviousDate}
                  entryData={entryData}
                  setEntryData={setEntryData}
                  weekDays={weekDays}
                  basicInfo={basicInfo}
                  setTableRowsCount={(val) => setTableRowsCount(val)}
                  dayEntry={(val: never) => {
                    if (editEntry) {
                      const previousStateValue = dayEntry;
                      previousStateValue[entryIndex] = val;
                      setDayEntry([...previousStateValue])
                    } else {
                      const previousStateValue = dayEntry;
                      previousStateValue.push(val);
                      setDayEntry([...previousStateValue])
                    }
                  }}
                />
              }
              <Container>
                <Row>
                  <Col>
                    <Table striped bordered hover style={{ marginTop: 20 }}  >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Date Worked</th>
                          <th>Day</th>
                          <th>Time In</th>
                          <th>Time Out</th>
                         {enableSupervisorInitials && <th>Supervisor Initials</th>}
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          dayEntry.map((day: any, index: any) => {
                            return <tr key={day.date}>
                              <td>{index + 1}</td>
                              <td>{moment(day.date).format("MMMM Do YYYY")}</td>
                              <td>{weekDays[new Date(day.date).getDay()]}</td>
                              <td>{moment(day[`${weekDays[new Date(day.date).getDay()].toLowerCase()}TimeIn`]).format("HH:mm").replace(':', '')}</td>
                              <td>{moment(day[`${weekDays[new Date(day.date).getDay()].toLowerCase()}TimeOut`]).format("HH:mm").replace(':', '')}</td>
                              {enableSupervisorInitials && (
                                <td>
                                  <SupervisorInitials
                                    day={weekDays[new Date(day.date).getDay()]}
                                    setInitialsDays={setInitialsDays}
                                    removeEntry={removeSupervisorInitialsEntry}
                                    editEntry={isUpdateEntry}
                                    previousDay={previousDate ? weekDays[new Date(previousDate).getDay()] : null}
                                    updatedDay={updatedDay ? weekDays[new Date(updatedDay).getDay()] : null}
                                  />
                                </td>
                              )}
                              <td>
                                <Row>
                                  <Col lg={6} xl={6}>
                                <Button
                                  type='button'
                                  variant="success"
                                  size={'sm'}
                                  disabled={entryIndex === index && editEntry}
                                  onClick={() => {
                                    setEntryIndex(index)
                                    setEditEntry(true)
                                    const selectedEntrydata = dayEntry.filter((day, i) => i === index)[0];
                                    setEntryData(selectedEntrydata);
                                    setShowEntryform(true)
                                    if (enableSupervisorInitials) {
                                      setIsUpdateEntry(false);
                                      setIsUpdatedDay(null);
                                      setPreviousDate(null)
                                    }
                                  }}
                                >
                                  <PencilFill />
                                </Button>
                                </Col >
                                <Col lg={6} xl={6}>
                                <Button
                                  type='button'
                                  variant="danger"
                                  size={'sm'}
                                  style={{ marginLeft: 'auto' }}
                                  disabled={entryIndex === index && editEntry}
                                  onClick={() => {
                                    setConfirmatioBox(true)
                                    setEntryIndex(index)
                                  }}
                                >
                                  <Trash />
                                </Button>
                                </Col >
                                </Row>
                              </td>
                            </tr>
                          })
                        }
                      </tbody>
                    </Table>
                    {!showHasDay &&
                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <p style={{ color: 'red' }}>You have no time logged, please use the "Add" button to log time now</p>
                      </div>
                    }
                  </Col>
                </Row>
                <Row>
                  { }
                  { }
                  {}
                  <Col>
                    {tableRowsCount ?
                      (!showEntryform && dayEntry.length > 0 && dayEntry.length < parseInt(tableRowsCount)) &&
                      <Button
                        type='button'
                        size='sm'
                        variant="success"
                        onClick={() => setShowEntryform(!showEntryform)}
                        style={{ float: 'right', marginTop: 10, marginBottom: 10 }}
                      >
                        Add Entry
                      </Button>
                      :
                      (!showEntryform && dayEntry.length > 0 && dayEntry.length < 7) &&
                      <Button
                        type='button'
                        size='sm'
                        variant="success"
                        onClick={() => setShowEntryform(!showEntryform)}
                        style={{ float: 'right', marginTop: 10, marginBottom: 10 }}
                      >
                        Add Entry
                      </Button>
                    }
                  </Col>
                </Row>
              </Container>
              <Questions
                  dayEntry={dayEntry}
                  weekDays={weekDays}
                  setQuestionResponses={setQuestionResponses}
                  dutyFreeLunchSchoolInitials={dutyFreeLunchSchoolInitials}
                  dutyFreeBreakSchoolInitials={dutyFreeBreakSchoolInitials}
                  setDutyFreeLunchSchoolSigTouched={setDutyFreeLunchSchoolSigTouched}
                  setDutyFreeBreakSchoolSigTouched={setDutyFreeBreakSchoolSigTouched}
                  dutyFreeLunchSchoolSigTouched={dutyFreeLunchSchoolSigTouched}
                  dutyFreeBreakSchoolSigTouched={dutyFreeBreakSchoolSigTouched}
                  state={basicInfo.state}
                  isTimesheetSubmit={isTimesheetSubmit}
                  setIsQuestionValidate={setIsQuestionvalidate}
                />
              <Disclaimer
                disclaimer={basicInfo}
                onValueChange={setDisclaimerChecked}
              />
              <Signature
                name='signature'
                title={"Employee Signature"}
                required
                reference={sigCanvas}
                setSigTouched={setSigTouched}
              />
              <div className={styles.SupervisorSection}>
                <Container>
                  <Row>
                    <Col lg={6} md={6} sm={12}>
                      <TextInput
                        title={basicInfo.state === 'CA' ? "School Official Name" : 'School Official Printed Name'}
                        onValueChange={setSupervisorFullName}
                        value={supervisorFullName}
                      />
                    </Col>
                  </Row>
                </Container>
                <Signature
                  name='supervisorSignature'
                  // required
                  title={basicInfo.state === 'CA' ? "School Official Signature" : "School Official Printed Signature"}
                  supervisor
                  reference={sigCanvasManager}
                  setSigTouched={setSigTouchedManager}
                />
              </div>
              <Container>
                <Row>
                  <Col>
                    <div className={styles.ErrorMessageNotice}>
                      {showHasDay ?  'Please fill in all of the required fields before submitting.' : 'You must enter at least 1 day before submitting.'}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className={styles.SubmitButtonContainer}>
                      <Button
                        type='submit'
                        variant="success"
                        size={'lg'}
                        disabled={submitDisabled}
                        onClick={(e) => {
                          setIsTimeSheetSubmit(true);
                          if (Object.keys(errors).length !== 0) {
                            window.scrollTo(0, 0)
                          }
                        }}
                      >
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Container>
            </form>
          )}
        </Formik>
      </Container>
      <InfoModal
        visibility={showModal}
        setShow={setShowModal}
        modalData={modalData}
      />
      <ConfirmationModal
        visibility={confirmationBox}
        setShow={setConfirmatioBox}
        removeEntry={async () => {
          if (enableSupervisorInitials) {
            const day = weekDays[new Date(dayEntry[entryIndex].date).getDay()];
            removeSupervisorInitialsEntry(day);
          }
          let newEntryArray = dayEntry.filter((_: any, i: any) => i !== entryIndex)
          setDayEntry([...newEntryArray]);
          setConfirmatioBox(false)
        }}
      />
    </div>
  );
};

export default Timesheet;
